/* tslint:disable */
/**
 * Scrivio Appointments API
 * API for managing appointments (afspraken) within an organization. All operations are scoped to the authenticated user\'s organization.  ## Session Types  The API supports four types of sessions:  ### Individual Sessions Standard one-on-one appointments with a single client and behandelaar. Use `clientId` for single client appointments.  ### Group Sessions (explicit clients) Appointments with multiple clients (e.g., group therapy, family sessions). Use `clientIds` array to specify multiple clients. Each client gets individual attendance tracking and billable quarters calculation.  ### Client Group Sessions (dynamic membership) Appointments linked to a Client Group. The participating clients are determined dynamically based on who is a member of the group on the appointment date. Use `groupId` to assign a client group. For recurring appointments, each instance resolves members independently based on its own `startTime`.  When `groupId` is set, the `clientIds` field is ignored (the group determines clients). The response includes: - `group`: Basic group info (id, name) - `participants`: Clients who are members of the group on the appointment date   (each entry carries `clientId`, `clientName`, and membership dates)  ### Multidisciplinary Sessions Appointments with multiple behandelaren (e.g., MDO - multidisciplinair overleg). Use `attendeeIds` array to add additional behandelaren beyond the primary `behandelaarId` (who becomes the organizer).  ### Internal Meetings Team meetings without clients. Use `category: \"INTERNAL\"` and omit client fields.  ## All-Day Appointments  All-day appointments (e.g., daily stay costs in residential care) span the entire day. Set `isAllDay: true` to create an all-day appointment. When `isAllDay` is true: - `startTime` should be set to the start of the day (00:00 / midnight) - `endTime` should be set to the end of the same day (23:59) - `durationMinutes` reads 1439 — the span is 00:00:00.000 through 23:59:59.999,   and the response derives the duration from those two times rather than storing it  All-day appointments are backwards compatible: existing appointments default to `isAllDay: false`. Note: multi-day appointments (spanning multiple days) are not currently supported.  ## Billable Quarters  For group sessions, each client\'s attendance is tracked individually: - `scheduledStartTime` / `scheduledEndTime` - copied from appointment - `actualStartTime` / `actualEndTime` - set during attendance registration - `billableQuarters` - auto-calculated as ceil(actualMinutes / 15)  Integrates with FullCalendar for calendar UI (see ADR-006). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

interface AWSv4Configuration {
  options?: {
    region?: string
    service?: string
  }
  credentials?: {
    accessKeyId?: string
    secretAccessKey?: string,
    sessionToken?: string
  }
}

export interface ConfigurationParameters {
    apiKey?: string | Promise<string> | ((name: string) => string) | ((name: string) => Promise<string>);
    username?: string;
    password?: string;
    accessToken?: string | Promise<string> | ((name?: string, scopes?: string[]) => string) | ((name?: string, scopes?: string[]) => Promise<string>);
    awsv4?: AWSv4Configuration;
    basePath?: string;
    serverIndex?: number;
    baseOptions?: any;
    formDataCtor?: new () => any;
}

export class Configuration {
    /**
     * parameter for apiKey security
     * @param name security name
     */
    apiKey?: string | Promise<string> | ((name: string) => string) | ((name: string) => Promise<string>);
    /**
     * parameter for basic security
     */
    username?: string;
    /**
     * parameter for basic security
     */
    password?: string;
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     */
    accessToken?: string | Promise<string> | ((name?: string, scopes?: string[]) => string) | ((name?: string, scopes?: string[]) => Promise<string>);
    /**
     * parameter for aws4 signature security
     * @param {Object} AWS4Signature - AWS4 Signature security
     * @param {string} options.region - aws region
     * @param {string} options.service - name of the service.
     * @param {string} credentials.accessKeyId - aws access key id
     * @param {string} credentials.secretAccessKey - aws access key
     * @param {string} credentials.sessionToken - aws session token
     * @memberof Configuration
     */
    awsv4?: AWSv4Configuration;
    /**
     * override base path
     */
    basePath?: string;
    /**
     * override server index
     */
    serverIndex?: number;
    /**
     * base options for axios calls
     */
    baseOptions?: any;
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    formDataCtor?: new () => any;

    constructor(param: ConfigurationParameters = {}) {
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.awsv4 = param.awsv4;
        this.basePath = param.basePath;
        this.serverIndex = param.serverIndex;
        this.baseOptions = {
            ...param.baseOptions,
            headers: {
                ...param.baseOptions?.headers,
            },
        };
        this.formDataCtor = param.formDataCtor;
    }

    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    public isJsonMime(mime: string): boolean {
        const jsonMime: RegExp = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
}
